"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEntryItem = exports.LogList = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var paginatedList_1 = require("../lib/paginatedList");
var circles_1 = require("../circles");
var moment = require("moment");
var LogList = (function (_super) {
    __extends(LogList, _super);
    function LogList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogList.prototype.render = function () {
        var props = this.props;
        return React.createElement("div", { className: "LogList" },
            React.createElement(paginatedList_1.PaginatedList, { pageSize: 10 }, props.elements.map(function (element) { return (React.createElement(LogEntryItem, { key: element.id, element: element })); })));
    };
    LogList = __decorate([
        mobx_react_1.observer
    ], LogList);
    return LogList;
}(React.Component));
exports.LogList = LogList;
var LogEntryItem = (function (_super) {
    __extends(LogEntryItem, _super);
    function LogEntryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogEntryItem.prototype.render = function () {
        var props = this.props;
        return React.createElement("div", { className: "LogEntryItem", ref: function (div) {
                $(div).off('click');
                $(div).click(function () { return openLog(props.element.id, "/".concat(props.element.project, "/log/").concat(props.element.id)); });
            } },
            React.createElement("div", null,
                React.createElement("span", { className: "font-weight-bold" }, props.element.changed_by),
                React.createElement("div", { className: "LogEntryItem__CircleContainer" }, moment(props.element.date).format("L LT"))),
            React.createElement("div", { className: "mb-2" },
                React.createElement("span", null,
                    props.element.object_identifier,
                    " ",
                    props.element.change_description,
                    " ",
                    (props.element.type_switch == 80 || props.element.type_switch == 90) ? props.element.target_object_identifier : ""),
                React.createElement("div", { className: "LogEntryItem__CircleContainer" }, props.element.note ?
                    React.createElement(circles_1.FilledCircle, null)
                    :
                        React.createElement(circles_1.EmptyCircle, null))));
    };
    LogEntryItem = __decorate([
        mobx_react_1.observer
    ], LogEntryItem);
    return LogEntryItem;
}(React.Component));
exports.LogEntryItem = LogEntryItem;
